import Vue from 'vue'
import VueRouter from 'vue-router'
import registration from "@/registration"
import appConfigGlobal from "@/app.config.global"

const appRoutes = registration.map(e => e.route);

Vue.use(VueRouter)

let routes = [
  {
    path: '/',
    name: 'App',
    redirect: appConfigGlobal.defaultRouteRedirect,
  },
  {
    path: '/settings',
    name: 'User Settings',
    component: () => import(/* webpackChunkName: "settings" */ '@/_views/my/Settings.vue'),
  },
  {
    path: '/logins',
    name: 'Logins',
    component: () => import(/* webpackChunkName: "Logins" */ '@/_views/my/Logins.vue'),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "About" */ '@/_views/about'),
  },
  
  ...appRoutes

];

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
})

// Navigation guard - authentication is handled before Vue app mounts in main.js
// So if we're here, user is authenticated. Just allow navigation.
router.beforeEach((to, from, next) => {
  // All authentication is handled before Vue mounts
  // If we reach here, user is authenticated
  next();
})

export default router
